<template>
    <div class="dialogueBox">
        <div class="headerBox">
            <div class="row_left">
                <img class="putonTopIcon" src="@/assets/putonTop.png" alt="" srcset="">
            </div>
            <div class="row_right">邀请</div>
        </div>
        <div class="rowBox">
            <div class="row_left">
                1
            </div>
            <div class="row_right">你喜欢吃什么菜？可以尝试亚洲美食吗！我可以做....</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.dialogueBox {
    width: 100%;
    height: 100%;
}

.headerBox {
    width: 100%;
    height: 88px;
    background: #F7F9FA;
    border-radius: 8px 8px 0px 0px;
    border: 1px solid #EEEEEE;
    display: flex;

    .row_left {
        // padding: 30px 40px;
        width: 100px;
        border-right: 1px solid #EEEEEE;
        display: flex;
        align-items: center;
        justify-content: center;
        .putonTopIcon {
            width: 18px;
            height: 22px;
        }

    }

    .row_right {
        flex: 1;
        text-align: center;
        align-items: center;
        line-height: 88px;
    }
}
.rowBox{
    width: 100%;
    height: 88px;
    // background: #F7F9FA;
    // border-radius: 8px 8px 0px 0px;
    border: 1px solid #EEEEEE;
    display: flex;
    border-top: none;

    .row_left {
        // padding: 30px 40px;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #EEEEEE;

        .putonTopIcon {
            width: 18px;
            height: 22px;
        }

    }

    .row_right {
        flex: 1;
        text-align: left;
        align-items: center;
        line-height: 88px;
        padding-left: 40px;
    }
}
</style>